import {
  InputLabelProps,
  OutlinedInputProps,
  SxProps,
  TextField
} from '@mui/material';
import React, { useRef } from 'react';
import { v4 as uuid } from 'uuid';

export interface ETOTextFieldProps {
  autoFocus?: boolean;
  disabled?: boolean;
  error?: string;
  id?: string;
  inputProps?: OutlinedInputProps['inputProps'];
  InputProps?: Partial<OutlinedInputProps>;
  inputLabelProps?: InputLabelProps;
  label?: string;
  maxRows?: number | string;
  minRows?: number | string;
  multiline?: boolean;
  name: string;
  size?: 'small' | 'medium';
  type?: 'number' | 'password';
  value?: any;
  handleChange?: React.ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  >;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  defaultValue?: any;
  sxProps?: SxProps;
  color?: 'error' | 'warning' | 'primary' | 'secondary' | 'info' | 'success' | undefined;
}

const ETOTextField: React.FC<React.PropsWithChildren<ETOTextFieldProps>> = (props) => {
  const {
    id,
    name,
    label,
    disabled,
    error,
    value,
    multiline,
    handleChange,
    type,
    autoFocus,
    size,
    inputProps,
    InputProps,
    maxRows,
    minRows,
    onFocus,
    onKeyDown,
    onBlur,
    defaultValue,
    inputLabelProps,
    sxProps,
    color
  } = props;

  const idRef = useRef(id ?? uuid());

  return (
    <TextField
      sx={sxProps}
      defaultValue={defaultValue}
      InputLabelProps={inputLabelProps}
      size={size}
      inputProps={inputProps}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      InputProps={InputProps}
      fullWidth
      autoFocus={autoFocus}
      name={name}
      type={type}
      id={idRef.current}
      multiline={multiline}
      disabled={disabled}
      label={label}
      variant="outlined"
      value={value}
      onChange={(e) => {
        if (handleChange) handleChange(e);
      }}
      helperText={error}
      error={Boolean(error)}
      maxRows={maxRows}
      minRows={minRows}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      color={color}
    />
  );
};

export default ETOTextField;
